import i18n from '../../../i18n';
import { ReactComponent as TimeIcon } from '../../../assets/icons/ic_action_time.svg';
import { ReactComponent as CallIcon } from '../../../assets/icons/ic_action_call_dark.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/icons/ic_action_phone.svg';
import { ReactComponent as WebsiteIcon } from '../../../assets/icons/ic_world_globe_dark.svg';
import { ReactComponent as WikipediaIcon } from '../../../assets/icons/ic_plugin_wikipedia.svg';
import { ReactComponent as PoiNameIcon } from '../../../assets/icons/ic_action_poi_name.svg';
import { ReactComponent as BrandIcon } from '../../../assets/icons/ic_action_poi_brand.svg';
import { ReactComponent as InternetIcon } from '../../../assets/icons/ic_action_internet_access_fee.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/ic_action_info_dark.svg';
import { ReactComponent as InstagramIcon } from '../../../assets/icons/ic_action_social_instagram.svg';
import { ReactComponent as CuisineIcon } from '../../../assets/icons/ic_action_cuisine.svg';
import { ReactComponent as DescriptionIcon } from '../../../assets/icons/ic_action_note_dark.svg';
import { ReactComponent as EmailIcon } from '../../../assets/icons/ic_action_at_mail.svg';
import { ReactComponent as WikidataIcon } from '../../../assets/icons/ic_action_logo_wikidata.svg';
import { ReactComponent as DisplayLanguageIcon } from '../../../assets/icons/ic_action_map_language.svg';
import { changeIconColor } from '../../../map/markers/MarkerOptions';
import { cleanHtml, createPoiCache, getIconNameForPoiType, updatePoiCache } from '../../../manager/PoiManager';
import { htmlToText } from '../../../frame/components/editor/htmlUtils';
import React from 'react';
import { apiGet, apiPost } from '../../../util/HttpApi';

import { localizeOpeningHours } from '../../../util/dateFmt';
import { getApiLang, WIKI_DEFAULT_LANG } from '../../../util/lang';
import {
    convertMeters,
    getSmallLengthUnit,
    getLargeLengthUnit,
    LARGE_UNIT,
    SMALL_UNIT,
} from '../../../menu/settings/units/UnitsConverter';

export const DEFAULT_TAG_ICON_SIZE = 24;
export const DEFAULT_TAG_ICON_COLOR = '#727272';
export const WEB_PREFIX = 'web_';
export const WEB_POI_PREFIX = 'web_poi_';
export const POI_PREFIX = 'poi_';
export const WIKIPEDIA = 'wikipedia';
const WIKIVOYAGE = 'wikivoyage';
export const OSM_WIKI = 'osmwiki';
export const AMENITY_PREFIX = 'amenity_';
export const TYPE = 'type';
export const SUBTYPE = 'subtype';
const TYPE_POI = WEB_POI_PREFIX + 'type';
const SUBTYPE_POI = WEB_POI_PREFIX + 'subType';
const SERVICE_TIMES = 'service_times';
const COLLECTION_TIMES = 'collection_times';
export const DESCRIPTION = 'description';
const SHORT_DESCRIPTION = 'short_description';
export const OPENING_HOURS = 'opening_hours';
const PHONE = 'phone';
const MOBILE = 'mobile';
const EMAIL = 'email';
const WEBSITE = 'website';
const CUISINE = 'cuisine';
export const CUISINE_PREFIX = 'cuisine_';
export const IMAGE_OSM_TAG = 'image';
export const MAPILLARY_OSM_TAG = 'mapillary';
export const WIKIDATA = 'wikidata';
export const WIKIMEDIA_COMMONS = 'wikimedia_commons';
const INSTAGRAM = 'instagram';
export const OSM_PREFIX = 'osm_tag_';
const SHORT_DESCRIPTION_TAG = OSM_PREFIX + SHORT_DESCRIPTION;
const COLLAPSABLE_PREFIX = 'collapsable_';
export const COLOR_NAME_EXTENSION = 'color';
const ICON_NAME_EXTENSION = 'icon';
export const BACKGROUND_TYPE_EXTENSION = 'background';
export const NAME = 'name';
export const EN_NAME = 'en_name';
export const ALT_NAME = 'osm_tag_alt_name';
const ORIGINAL_ICON = 'originalIcon';
const MARKER_ICON_SVG = 'svg';
const MARKER_OBJ_ID = 'idObj';
export const RELATED_RESULT_IDS = 'relatedResultIds';
export const MARKER_INTERNAL_KEYS = [MARKER_ICON_SVG, MARKER_OBJ_ID, ICON_NAME_EXTENSION, RELATED_RESULT_IDS];

// from Amenity object
export const POI_NAME = WEB_POI_PREFIX + 'name';
export const POI_TYPE = WEB_POI_PREFIX + 'type';
export const POI_SUBTYPE = WEB_POI_PREFIX + 'subType';
export const POI_ICON_NAME = WEB_POI_PREFIX + 'iconName';
export const FINAL_POI_ICON_NAME = WEB_POI_PREFIX + 'finalIconName';
export const POI_OSM_URL = WEB_POI_PREFIX + 'osmUrl';
export const POI_ID = WEB_POI_PREFIX + 'id';
export const POI_FROM_TAGS = WEB_POI_PREFIX + 'from_tags';

// from PoiType object
export const CATEGORY_NAME = WEB_PREFIX + 'name';
export const CATEGORY_TYPE = WEB_PREFIX + 'type';
export const CITY = WEB_PREFIX + 'city';
export const ADDRESS_1 = WEB_PREFIX + 'address1';
export const ADDRESS_2 = WEB_PREFIX + 'address2';
export const MATCHED_OBJECTS = WEB_PREFIX + 'matched_objects';
// the other name (synonym, another language) the query matched, e.g. "Schule" for the category "Школа"
export const MATCHED_ALT_NAME = WEB_PREFIX + 'alt_name';
export const BBOX_LAT_LON = WEB_PREFIX + 'bbox_lat_lon';
export const CATEGORY_KEY_NAME = WEB_PREFIX + 'keyName';
export const ICON_KEY_NAME = WEB_PREFIX + 'iconKeyName';
export const TYPE_OSM_TAG = WEB_PREFIX + 'typeOsmTag';
export const TYPE_OSM_VALUE = WEB_PREFIX + 'typeOsmValue';
export const CATEGORY_ICON = WEB_PREFIX + 'categoryIcon';
export const MAIN_CATEGORY_KEY_NAME = WEB_PREFIX + 'categoryKeyName';
export const WEB_POI_FILTER_NAME = WEB_PREFIX + 'poiFilterName';
export const WEB_POI_ADDITIONAL_CATEGORY = WEB_PREFIX + 'poiAdditionalCategory';
export const WEB_VISIBLE_LEVEL = WEB_PREFIX + 'visible_level';
export const POI_ELO = WEB_PREFIX + 'poi_elo';
export const TRANSPORT_STOP_ID = WEB_PREFIX + 'transport_stop_id';

export const MAPILLARY_ACCESS_TOKEN = 'MLY|4444816185556934|29475a355616c979409a5adc377a00fa';
export const GRAPH_URL_ENDPOINT = 'https://graph.mapillary.com/';
export const PARAM_ACCESS_TOKEN = 'access_token=' + MAPILLARY_ACCESS_TOKEN;
export const PARAM_FIELDS = 'fields=id,geometry,compass_angle,captured_at,camera_type,thumb_256_url,thumb_1024_url';

export const TITLE = 'title';

const WEB_TAGS_TO_SKIP = [
    ICON_KEY_NAME,
    POI_ICON_NAME,
    TYPE_OSM_TAG,
    TYPE_OSM_VALUE,
    TITLE,
    FINAL_POI_ICON_NAME,
    TYPE_POI,
    SUBTYPE_POI,
    POI_NAME,
    POI_ID,
    POI_OSM_URL,
];
export const SEPARATOR = ';';

const IconComponent = ({ svg, size, color }) => {
    const coloredSvg = changeIconColor(svg, color);
    const svgWithUpdatedSize = coloredSvg
        .replace(/(width=")[^"]*(")/g, `$1${size}$2`)
        .replace(/(height=")[^"]*(")/g, `$1${size}$2`);

    return <div dangerouslySetInnerHTML={{ __html: svgWithUpdatedSize }} />;
};

/**
 * Retrieves an SVG icon for a given POI using key-value pairs.
 * This function can also handle different types of POI data structures based on the 'getPoiType' flag.
 *
 * @param {Object} params - The parameters for fetching or creating the SVG icon.
 * @param {string|null} params.key - The key used to identify the type of POI. Optional.
 * @param {string|null} params.value - The value associated with the key for the POI. Optional.
 * @param {Object} params.ctx - The context object containing necessary caches and other contextual data.
 * @param {boolean} params.getPoiType - Flag to determine the structure of POI data handling.
 * @param {string|null} params.icon - An optional icon identifier that can override default behavior.
 * @returns {Promise<string|null>} - A Promise that resolves to the SVG icon data as a string, or null if no icon is found.
 *
 * Details:
 * - If `getPoiType` is true, the function prepares a list of POIs with properties derived from the key and value, then passes this to `createPoiCache`.
 * - If `getPoiType` is false, the function processes either a given object or just the key after stripping a prefix.
 * - The function updates the global `poiIconCache` with any new or existing icons found or fetched during the cache creation process.
 * - Finally, it attempts to return the most relevant icon from the cache. If no suitable icon is found, it returns null.
 */
export async function getSvgIcon({ key = null, value = null, ctx, getPoiType = false, icon = null }) {
    let innerCache;
    let cacheValue;
    if (getPoiType) {
        const poiList = [{ properties: { [TYPE_OSM_TAG]: key, [TYPE_OSM_VALUE]: value } }];
        innerCache = await createPoiCache({
            poiList,
            poiIconCache: ctx.poiIconCache,
            icon,
        });
        cacheValue = icon ? innerCache[icon] : innerCache[`${key}_${value}`];
    } else {
        const prepKey = key?.replace(COLLAPSABLE_PREFIX, '');
        innerCache = await createPoiCache({
            obj: { key: prepKey, value },
            poiIconCache: ctx.poiIconCache,
            icon,
        });
        cacheValue = innerCache[icon] ?? innerCache[prepKey] ?? innerCache[value];
    }
    updatePoiCache(ctx, innerCache);
    return cacheValue ?? null;
}

export function getIcon(svgData, size, color) {
    if (svgData) {
        return <IconComponent svg={svgData} size={size} color={color} />;
    }
    return <InfoIcon style={{ width: size, height: size, fill: color }} />;
}

async function getWptTags(obj, type, ctx) {
    let tags;
    let res = [];
    let rawTags = {};
    let typeTag = null;
    let subtypeTag = null;
    let id = null;
    if (type.isFav || type.isWpt) {
        tags = obj.ext?.extensions;
    } else if ((type.isPoi || type.isSearch) && obj.options) {
        Object.entries(obj.options).forEach(([key, value]) => {
            if (value === undefined) {
                delete obj.options[key];
            }
        });
        tags = obj.options;
    } else if (type.isWikiPoi) {
        Object.entries(obj.properties).forEach(([key, value]) => {
            if (value === undefined) {
                delete obj.properties[key];
            }
        });
        tags = obj.properties;
    }

    if (tags) {
        typeTag = tags[AMENITY_PREFIX + TYPE] ?? tags[TYPE];
        subtypeTag = tags[AMENITY_PREFIX + SUBTYPE] ?? tags[SUBTYPE_POI];
        id = tags[POI_ID];

        if (type.isFav || type.isWpt || type.isWikiPoi) {
            const icon = getIconNameForPoiType({
                iconKeyName: tags[ICON_KEY_NAME],
                typeOsmTag: tags[TYPE_OSM_TAG],
                typeOsmValue: tags[TYPE_OSM_VALUE],
            });
            const tagTypeObj = await addPoiTypeTag({ key: tags[TYPE_OSM_TAG], value: tags[TYPE_OSM_VALUE], ctx, icon });
            if (tagTypeObj) {
                res.push(tagTypeObj);
            }
        }

        // poiNameTags: localized web_poi_name* keys (POI name block);
        // wikiTags: wikidata/wikipedia, bypass the server visibility filter;
        // mainTags: everything else, filtered from web service keys.
        const { poiNameTags, wikiTags, mainTags } = splitTags(tags);
        rawTags = buildRawTags(wikiTags, mainTags);

        for (const [key, value] of Object.entries(wikiTags)) {
            const tagKey = key.includes(WIKIDATA) ? WIKIDATA : WIKIPEDIA;
            const tagObj = await buildTagObj({ key: tagKey, value: value, lang: null, ctx, subtypeTag });
            if (tagObj) {
                res.push(tagObj);
            }
        }

        const tagList = await fetchVisibleTags(mainTags);

        for (const entry of tagList) {
            let tagObj = await buildTagObj({
                key: entry.key,
                value: entry.value,
                lang: entry.lang,
                generic: entry.generic,
                ctx,
                subtypeTag,
            });

            if (entry.otherLangs?.length) {
                tagObj.otherLangs = await buildOtherLangTags(entry.otherLangs, ctx, subtypeTag, entry.key);
            }
            if (entry.labels) {
                tagObj.labels = entry.labels;
            }

            res.push(tagObj);
        }

        const poiNameTagObj = await buildPoiNameTagObj(poiNameTags, ctx, subtypeTag);
        if (poiNameTagObj) {
            res.push(poiNameTagObj);
        }
    }

    return { res, rawTags, id, type: typeTag, subtype: subtypeTag };
}

async function buildTagObj({ key, value, lang, generic, ctx, subtypeTag }) {
    let tagObj = { key };
    tagObj.value = value;
    tagObj.isUrl = isUrl(value);
    if (key.includes(WIKIPEDIA)) {
        tagObj.url = getWikiParams(key, value).url;
        tagObj.isUrl = true;
    } else if (!tagObj.isUrl) {
        tagObj.socialMediaUrl = getSocialMediaUrl(key, value);
        if (tagObj.socialMediaUrl != null) {
            tagObj.isUrl = true;
        }
    }

    Object.assign(tagObj, await getTagIconProps({ key, value, lang, generic, ctx }));

    const [formattedPrefix, formattedValue] = getFormattedPrefixAndText(key, tagObj.textPrefix, value, subtypeTag, ctx);
    tagObj.textPrefix = formattedPrefix;
    tagObj.value = formattedValue;

    applyCollapsablePrefix(tagObj, key);
    applySharedNameTag(tagObj);

    if (tagObj.key === OPENING_HOURS) {
        tagObj.value = localizeOpeningHours(tagObj.value);
    }

    if (key.includes(WIKIDATA)) {
        tagObj = addWikidataTags(key, value, tagObj);
    }

    if (lang) {
        tagObj.lang = lang;
        tagObj.textPrefix = `${tagObj.textPrefix}:${lang}`;
    }

    return tagObj;
}

async function getTagIconProps({ key, value, lang, generic, ctx }) {
    switch (key) {
        case WIKIPEDIA:
            return { icon: <WikipediaIcon /> };
        case CUISINE:
            return { icon: <CuisineIcon /> };
        case SERVICE_TIMES:
        case COLLECTION_TIMES:
            return { icon: <TimeIcon />, needLinks: false, textPrefix: value };
        case OPENING_HOURS:
            return { icon: <TimeIcon /> };
        case PHONE:
            return { icon: <CallIcon />, isPhoneNumber: true };
        case MOBILE:
            return { icon: <PhoneIcon />, isPhoneNumber: true };
        case WEBSITE:
            return { icon: <WebsiteIcon />, isUrl: true };
        case DESCRIPTION:
            return { icon: <DescriptionIcon />, desc: true };
        case INSTAGRAM:
            return { icon: <InstagramIcon /> };
        case EMAIL:
            return { icon: <EmailIcon />, isEmail: true };
        case 'addr:housename':
        case 'whitewater:rapid_name':
            return { icon: <PoiNameIcon /> };
        case 'internet_access_fee_yes':
            return { icon: <InternetIcon /> };
        default:
            if (generic) {
                return getGenericTagProps(key);
            }
            return await getOtherTagIconProps({ key, value, lang, ctx });
    }
}

function getGenericTagProps(key) {
    return {
        icon: getIcon(null, DEFAULT_TAG_ICON_SIZE, DEFAULT_TAG_ICON_COLOR),
        textPrefix: key.slice(key.indexOf(':') + 1),
        isRawValue: true,
    };
}

async function getOtherTagIconProps({ key, value, lang, ctx }) {
    if (key.startsWith('operator') || key.startsWith('brand')) {
        return { icon: <BrandIcon /> };
    }
    if (key.includes('internet_access')) {
        const prepValue = value.replace(TYPE, '').replace('__', '_');
        const svgData = await getSvgIcon({ value: prepValue, ctx });
        return { icon: getIcon(svgData, DEFAULT_TAG_ICON_SIZE, DEFAULT_TAG_ICON_COLOR) };
    }
    if (lang) {
        return { icon: <DisplayLanguageIcon /> };
    }
    const svgData = await getSvgIcon({ key, value, ctx });

    return { icon: getIcon(svgData, DEFAULT_TAG_ICON_SIZE, DEFAULT_TAG_ICON_COLOR) };
}

function applyCollapsablePrefix(tagObj, key) {
    if (key.startsWith(COLLAPSABLE_PREFIX)) {
        tagObj.collapsable = true;
        tagObj.textPrefix = key.replace(COLLAPSABLE_PREFIX, '');
        if (tagObj.textPrefix === CUISINE) {
            tagObj.icon = <CuisineIcon />;
        }
    }
}

function applySharedNameTag(tagObj) {
    if (tagObj.key.startsWith(POI_NAME)) {
        tagObj.key = tagObj.key.replace(POI_NAME, 'shared_string_name');
        tagObj.textPrefix = tagObj.key;
    }
}

async function buildPoiNameTagObj(poiNameTags, ctx, subtypeTag) {
    const entries = Object.entries(poiNameTags).map(([key, value]) => {
        const [base, lang] = key.split(':');
        return lang ? { key: base, value, lang } : { key: base, value };
    });

    const mainEntry =
        entries.find((entry) => entry.lang === i18n.language) ?? entries.find((entry) => entry.lang) ?? entries[0];
    if (!mainEntry) {
        return null;
    }

    const tagObj = await buildTagObj({
        key: mainEntry.key,
        value: mainEntry.value,
        lang: mainEntry.lang,
        ctx,
        subtypeTag,
    });
    const otherEntries = entries.filter((entry) => entry !== mainEntry);
    if (otherEntries.length > 0) {
        tagObj.otherLangs = await buildOtherLangTags(otherEntries, ctx, subtypeTag, mainEntry.key);
    }

    return tagObj;
}

async function buildOtherLangTags(entries, ctx, subtypeTag, key) {
    return Promise.all(
        entries.map((entry) => buildTagObj({ key, value: entry.value, lang: entry.lang, ctx, subtypeTag }))
    );
}

export async function addPoiTypeTag({
    key,
    value,
    icon,
    ctx,
    size = DEFAULT_TAG_ICON_SIZE,
    color = DEFAULT_TAG_ICON_COLOR,
}) {
    if (!icon) {
        return null;
    }
    let tagObj = {};
    let svgData = await getSvgIcon({ key, value, ctx, getPoiType: true, icon });
    if (!svgData) {
        svgData = await getSvgIcon({ key: 'amenity', value, ctx, getPoiType: true, icon });
    }
    tagObj.icon = getIcon(svgData, size, color);
    tagObj.key = 'type';
    tagObj.value = value;
    tagObj.textPrefix = value;

    return tagObj;
}

export function stringifyTagValues(tags) {
    return Object.fromEntries(
        Object.entries(tags).map(([key, value]) => [
            key,
            typeof value === 'number' || typeof value === 'boolean' ? String(value) : value,
        ])
    );
}

async function fetchVisibleTags(tags) {
    if (Object.keys(tags).length === 0) return [];
    tags = stringifyTagValues(tags);
    const response = await apiPost(`${process.env.REACT_APP_USER_API_SITE}/search/visible-tags`, tags, {
        apiCache: true,
        params: { lang: getApiLang(i18n.language) },
    });

    return Array.isArray(response?.data) ? response.data : Object.entries(tags).map(([key, value]) => ({ key, value }));
}

function splitTags(tags) {
    const poiNameTags = {};
    const wikiTags = {};
    const mainTags = {};
    for (const [key, value] of Object.entries(tags)) {
        if (key.startsWith(POI_NAME) && value) {
            poiNameTags[key] = value;
        } else if (key.includes(WIKIDATA) || key.includes(WIKIPEDIA)) {
            wikiTags[key] = value;
        } else {
            mainTags[key] = value;
        }
    }
    return { poiNameTags, wikiTags, mainTags: filterWebKeys(mainTags) };
}

function buildRawTags(...tagMaps) {
    const rawTags = {};
    for (const tags of tagMaps) {
        for (const [key, value] of Object.entries(tags)) {
            rawTags[key.replace(OSM_PREFIX, '')] = value;
        }
    }
    return rawTags;
}

function filterWebKeys(tags) {
    let res = {};
    for (const [key, value] of Object.entries(tags)) {
        if (
            key.startsWith(WEB_PREFIX) ||
            key.startsWith(ALT_NAME) ||
            WEB_TAGS_TO_SKIP.includes(key) ||
            key.startsWith(ORIGINAL_ICON) ||
            MARKER_INTERNAL_KEYS.includes(key)
        ) {
            continue;
        }
        res[key] = value;
    }

    return res;
}

function isNumeric(value) {
    const IS_NUMERIC_REGEX = /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/;
    return IS_NUMERIC_REGEX.test(value);
}

function formatLengthValue(value, ctx, unitType) {
    const numValue = isNumeric(value) ? Number(value) : undefined;
    if (numValue === undefined || !ctx.unitsSettings.len) {
        return value;
    }
    const unit = unitType === LARGE_UNIT ? getLargeLengthUnit(ctx) : getSmallLengthUnit(ctx);
    const converted = convertMeters(numValue, ctx.unitsSettings.len, unitType);
    return `${+converted.toFixed(1)} ${i18n?.t(unit)}`;
}

function getFormattedPrefixAndText(key, prefix, value, subtype, ctx) {
    let formattedPrefix = prefix ?? key;
    let formattedValue = value;

    switch (key) {
        case 'ele':
            formattedValue = formatLengthValue(value, ctx, SMALL_UNIT);
            break;
        case 'width':
            formattedPrefix = i18n?.t('shared_string_width');
            formattedValue = formatLengthValue(value, ctx, SMALL_UNIT);
            break;
        case 'height':
            formattedPrefix = i18n?.t('shared_string_height');
            formattedValue = formatLengthValue(value, ctx, SMALL_UNIT);
            break;
        case 'depth':
        case 'seamark_height':
            formattedValue = formatLengthValue(value, ctx, SMALL_UNIT);
            break;
        case 'distance':
            formattedPrefix = `${formattedPrefix} ${i18n?.t('distance')}`;
            formattedValue = formatLengthValue(value, ctx, LARGE_UNIT);
            break;
        case 'capacity':
            if (subtype === 'water_tower' || subtype === 'storage_tank') {
                formattedValue = `${value} ${i18n?.t('cubic_m')}`;
            }
            break;
        case 'maxweight':
            const numValue = parseFloat(value);
            if (Number.isFinite(numValue)) {
                const formatted = Number.isInteger(numValue) ? numValue.toString() : numValue.toFixed(1);
                formattedValue = `${formatted} ${i18n?.t('metric_ton')}`;
            }
            break;
        case 'students':
        case 'spots':
        case 'seats':
            if (isInt(value)) {
                formattedPrefix = `${prefix} ${i18n?.t('capacity')}`;
            }
            break;
    }
    return [formattedPrefix, formattedValue];
}

function isInt(n) {
    return !isNaN(parseInt(n)) && parseFloat(n) === parseInt(n);
}

function getSocialMediaUrl(key, value) {
    if (typeof value !== 'string') {
        return null;
    }
    // Remove leading and closing slashes
    let trimmedValue = value.trim();
    if (trimmedValue.charAt(0) === '/') {
        trimmedValue = trimmedValue.substring(1);
    }
    if (trimmedValue.endsWith('/')) {
        trimmedValue = trimmedValue.substring(0, trimmedValue.length - 1);
    }

    if (isUrl(trimmedValue)) {
        return trimmedValue;
    }
    if (trimmedValue.includes('/')) {
        return 'https://' + trimmedValue;
    }

    const urls = {
        facebook: 'https://facebook.com/%s',
        vk: 'https://vk.com/%s',
        instagram: 'https://instagram.com/%s',
        twitter: 'https://x.com/%s',
        ok: 'https://ok.ru/%s',
        telegram: 'https://t.me/%s',
        flickr: 'https://flickr.com/%s',
        youtube: 'https://youtube.com/channel/%s',
    };

    if (Object.hasOwn(urls, key)) {
        return urls[key].replace('%s', trimmedValue);
    } else {
        return null;
    }
}

export function addWikidataTags(key, value, tagObj) {
    tagObj.value = value;
    tagObj.url = 'https://www.wikidata.org/wiki/' + value;
    tagObj.isUrl = true;
    tagObj.icon = <WikidataIcon />;

    return tagObj;
}

function getWikiParams(key, value) {
    let title = null;
    let langCode = 'en';
    // Full OpenStreetMap Wikipedia tag pattern looks like "operator:wikipedia:lang_code",
    // "operator" and "lang_code" is optional parameters and may be skipped.
    if (key.includes(':')) {
        let tagParts = key.split(':');
        if (tagParts.length === 3) {
            // In this case tag contains all 3 parameters: "operator", "wikipedia" and "lang_code".
            langCode = tagParts[2];
        } else if (tagParts.length === 2) {
            // In this case one of the optional parameters was skipped.
            // Parameters never change their order and parameter "wikipedia" is always present.
            if (tagParts[0] === 'wikipedia') {
                // So if "wikipedia" is the first parameter, then parameter "operator" was skipped.
                // And the second parameter is "lang_code".
                langCode = tagParts[1];
            }
        }
    }
    // Value of an Wikipedia item can be an URL, but it is not recommended.
    // OSM users should use the following pattern "lang_code:article_title" instead.
    // Where "lang_code" is optional parameter for multilingual wikipedia tags.
    let url;
    if (isUrl(value)) {
        // In this case a value is already represented as an URL.
        url = value;
    } else {
        if (value.includes(':')) {
            // If value contains a sign ":" it means that "lang_code" is also present in value.
            let valueParts = value.split(':');
            langCode = valueParts[0];
            title = valueParts[1];
        } else {
            title = value;
        }
        // Full article URL has a pattern: "http://lang_code.wikipedia.org/wiki/article_name"
        let formattedTitle = title.replace(/ /g, '_');
        url = 'https://' + langCode + '.wikipedia.org/wiki/' + formattedTitle;
    }
    return { text: title !== null ? title : value, url };
}

function isUrl(value) {
    try {
        const { protocol } = new URL(value);
        return protocol === 'http:' || protocol === 'https:';
    } catch (_) {
        return false;
    }
}

export function openWikipediaContent(tag, setDevWikiContent) {
    if (tag.key === WIKIPEDIA) {
        getWikipediaContent(tag).then((data) => {
            if (data) {
                data = fixWikiUrl(data);
                setDevWikiContent(data);
            }
        });
    }
}

export function openWikivoyageContent(link, setDevWikiContent) {
    if (link) {
        getWikivoyageContent(link).then((data) => {
            if (data) {
                setDevWikiContent(data);
            }
        });
    }
}

function fixWikiUrl(text) {
    const urlRegex = /href="([^"]*)"/g;
    return text.replace(urlRegex, (match, w) => {
        if (w.includes('wikpedia')) {
            const fixedUrl = w.replace('wikpedia', WIKIPEDIA);
            return `href="${fixedUrl}"`;
        }
        return match;
    });
}

async function getWikipediaContent(tag) {
    const wikiData = parseUrl(tag.url ?? tag.value, WIKIPEDIA);
    if (!wikiData) {
        return null;
    }
    let response = await apiGet(`${process.env.REACT_APP_USER_API_SITE}/search/get-wiki-content`, {
        apiCache: true,
        params: {
            title: wikiData.title,
            lang: wikiData.lang,
        },
    });
    if (response?.data) {
        return response.data;
    } else {
        return null;
    }
}

async function getWikivoyageContent(link) {
    const wikivoyageData = parseUrl(link[1], WIKIVOYAGE);
    if (!wikivoyageData) {
        return null;
    }
    let response = await apiGet(`${process.env.REACT_APP_USER_API_SITE}/search/get-wikivoyage-content`, {
        apiCache: true,
        params: {
            title: wikivoyageData.title,
            lang: wikivoyageData.lang,
        },
    });
    if (response?.data) {
        return response.data;
    } else {
        return null;
    }
}

function parseUrl(url, site) {
    // a language code may hold a dash or a digit: be-tarask, zh-min-nan, nds-nl
    const regex = new RegExp(`https?://([a-z0-9-]+)\\.${site}\\.org/wiki/(.+)`);
    const match = url.match(regex);

    if (match) {
        const lang = match[1];
        const title = decodeURIComponent(match[2]).replace(/_/g, ' ');
        return {
            lang,
            title,
        };
    } else {
        return null;
    }
}

export function filterTag(tag) {
    return tag.key !== WIKIMEDIA_COMMONS && !otherImgTags(tag.key) && tag.key !== MARKER_ICON_SVG && tag.key !== 'type';
}

export const otherImgTags = (tag) => {
    return tag === IMAGE_OSM_TAG || tag === MAPILLARY_OSM_TAG;
};

export function getOsmIdFromOsmUrl(url) {
    return url ? url.split('/').pop() : null;
}

export function getShortDescriptionKey(lang) {
    return lang && lang !== WIKI_DEFAULT_LANG ? `${SHORT_DESCRIPTION_TAG}:${lang}` : SHORT_DESCRIPTION_TAG;
}

export function getShortDescriptionLang(key) {
    return key.split(':')[1] ?? WIKI_DEFAULT_LANG;
}

export function isShortDescriptionTag(key) {
    return key === SHORT_DESCRIPTION_TAG || key.startsWith(`${SHORT_DESCRIPTION_TAG}:`);
}

export function getShortDescriptions(extensions) {
    return Object.fromEntries(Object.entries(extensions ?? {}).filter(([key]) => isShortDescriptionTag(key)));
}

export function cleanShortDescriptions(shortDescriptions) {
    return Object.fromEntries(
        Object.entries(shortDescriptions)
            .map(([key, value]) => [key, htmlToText(cleanHtml(value ?? ''))])
            .filter(([, value]) => value)
    );
}

const WptTagsProvider = {
    getWptTags,
};
export default WptTagsProvider;
